import { useTicketUnreadItemsPoller } from "../api/ticket/pollers/useTicketUnreadItemsPoller";

/**
 * Initialises poller to refetch total unreads
 */
export const ConciergeTicketUnreadItemsInitialiser = () => {
    useTicketUnreadItemsPoller();
    return null;
};
